module.exports = __webpack_public_path__ + "img/MIDI-arpeggiator-plugin-vst-purple.aa0106b5.png";